export const AllMarketsId = "-1";
//# sourceMappingURL=marketIds.js.map